module.exports = __webpack_public_path__ + "static/img/logo_buttom.6dda085.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/logo_buttom.png
// module id = M8Ka
// module chunks = 1 2 3 4 5 6 7 8